<div class="help-container">
  <div class="drone-flying">
    <img class="icon" src="../assets/svg/icons8-drone_flight_1.svg" />
  </div>
  <div class="text-container" *ngIf="user$ | async; let user">
    <h2>{{ 'help.greeting' | translate: { name: user.firstName } }}</h2>
    <p>{{ 'help.message' | translate }}</p>
  </div>
</div>
